export const ROLE_LABELS = {
  developer: "Developer",
  super_admin: "Super Admin",
  admin: "Admin",
  accounts_admin: "Accounts Admin",
  community_admin: "Community Admin",
  creator: "Creator",
};

export const ROLE_ORDER = [
  "developer",
  "super_admin",
  "admin",
  "accounts_admin",
  "community_admin",
  "creator",
];

export const MODULE_ACCESS = {
  developer: [
    "dashboard",
    "tournaments",
    "users",
    "leads",
    "kyc",
    "communities",
    "wallet",
    "reports",
    "settings",
    "admins",
    "creators",
  ],
  super_admin: [
    "dashboard",
    "tournaments",
    "users",
    "leads",
    "kyc",
    "communities",
    "wallet",
    "reports",
    "settings",
    "admins",
    "creators",
  ],
  admin: [
    "dashboard",
    "tournaments",
    "users",
    "kyc",
    "communities",
    "reports",
    "settings",
  ],
  accounts_admin: ["dashboard", "kyc", "wallet", "reports"],
  community_admin: ["dashboard", "communities", "reports"],
  creator: ["dashboard", "creators"],
};

export const MODULE_LABELS = {
  dashboard: "Overview",
  tournaments: "Tournaments",
  users: "Users",
  leads: "Leads",
  kyc: "KYC Approvals",
  communities: "Communities",
  wallet: "Wallet & Payments",
  reports: "Reports",
  settings: "Settings",
  admins: "Admins",
  creators: "Creators",
};

export const roleHasAccess = (role, moduleId, accessMap = MODULE_ACCESS) => {
  if (!role || !moduleId) return false;
  const modules =
    accessMap?.[role] || MODULE_ACCESS[role] || [];
  return modules.includes(moduleId);
};

export const canManageAdmins = (role) =>
  role === "developer" || role === "super_admin";

export const canGrantRole = (currentRole, targetRole) => {
  if (!currentRole || !targetRole) return false;
  if (currentRole === "developer") return true;
  if (currentRole === "super_admin") {
    return ["admin", "accounts_admin", "community_admin", "creator"].includes(
      targetRole
    );
  }
  return false;
};

export const getAssignableRoles = (currentRole) => {
  if (currentRole === "developer") return ROLE_ORDER;
  if (currentRole === "super_admin") {
    return ["admin", "accounts_admin", "community_admin", "creator"];
  }
  return [];
};
